import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-summary',
  templateUrl: './card-summary.component.html',
  styleUrls: ['./card-summary.component.scss']
})
export class CardSummaryComponent implements OnInit {

  @Input() label: string;
  @Input() count: number;
  @Input() matIcon: string;

  constructor() { }

  ngOnInit(): void {
  }

}
